import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row } from 'reactstrap';
import {
  faLock,
  faLockOpen,
  faMinus,
  faPlus,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';
import NumberFormat from 'react-number-format';
import Icon from './UI/Icon';
import '../styles/cards.css';
import isUserHasProfile from '../helpers/profileValidator';
import { GARANTIA_EDIT_WRITE, GARANTIA_EXPOSICION_MAXIMA_WRITE } from '../helpers/profilePermission';

const isUserHasProfileByNode = (node) => {
  if (node.block_name === 'exposicion_maxima'){
    return isUserHasProfile(GARANTIA_EXPOSICION_MAXIMA_WRITE);
  }
  return isUserHasProfile(GARANTIA_EDIT_WRITE);
}

const TripleLineCard = ({ detail, handleEdit, handleView, node }) => {
  const isDisabledFirst = detail[`mov_${node.nemotecnico_first}_borrador`];
  const isDisabledSecond = detail[`mov_${node.nemotecnico_second}_borrador`];
  return (
    <div className="card-wrapper indirecta">
      <div className="text-center card-text">
        <div className="title font-weight-bold pt-1" style={{fontSize: "16px"}}>
          {node.block_name}
        </div>
      </div>
      <Row className="indirecta d-flex justify-content-between m-0">
        <div className="text-left font-weight-bold col-md-4 p-0">
          Total
        </div>
        <div className="font-weight-bold col-md-5 text-right p-0">
          <NumberFormat
            decimalScale="2"
            fixedDecimalScale
            decimalSeparator=","
            displayType="text"
            value={detail.balance[node.total]}
            thousandSeparator="."
          />
          &nbsp; UF
        </div>
        <div className="col-md-3 d-flex justify-content-end p-0">
          &nbsp;
        </div>
      </Row>
      <Row className="indirecta d-flex m-0">
        <div className="text-left col-md-4 p-0">
          {node.label_first}
        </div>
        <div className="col-md-5 text-right p-0">
          <NumberFormat
            decimalScale="2"
            fixedDecimalScale
            decimalSeparator=","
            displayType="text"
            value={detail.balance[node.nemotecnico_first]}
            thousandSeparator="."
          />
          &nbsp; UF
        </div>
        <div className="col-md-3 d-flex justify-content-end p-0">
          <Icon
            className="detail"
            handleOnClick={e => handleView(e, {
              tipo_id: node.tipo_id_first,
              label: node.label_first,
              nemotecnico: node.nemotecnico_first
            }, false)}
            id={`show-${node.block_name}${node.nemotecnico_first}`}
            placement="right"
            tooltipText={(
              <span className="show-tooltip">
                Ver Tabla
              </span>
            )}
          >
            <FontAwesomeIcon
              className="table-link"
              icon={faSearch}
            />
          </Icon>

          {node.block_name === 'Cúmulo' ? (
            <>
              <Icon
                className="Bloquear"
                handleOnClick={e => handleEdit(e, {
                  tipo_id: node.tipo_id_first,
                  label: node.label_first,
                  nemotecnico: node.nemotecnico_first
                })}
                id={`block-${node.block_name}${node.nemotecnico_first}`}
                placement="right"
                tooltipText={(
                  <span className="show-tooltip">
                    {detail.balance.bloqueada ? 'Desbloquear' : 'Bloquear'}
                  </span>
                )}
              >
                <FontAwesomeIcon
                  className="table-link"
                  icon={detail.balance.bloqueada ? faLockOpen : faLock}
                />
              </Icon>
            </>
          ) :
          (
            <>
              <Icon
                className="detail"
                handleOnClick={e => handleEdit(e, {
                  tipo_id: node.tipo_id_first,
                  label: node.label_first,
                  nemotecnico: node.nemotecnico_first
                }, true)}
                id={`increase-${node.block_name}${node.nemotecnico_first}`}
                isDisabled={isDisabledFirst}
                placement="right"
                tooltipText={(
                  <span className="show-tooltip">
                    Aumentar
                  </span>
                )}
              >
                <FontAwesomeIcon
                  className="table-link"
                  icon={faPlus}
                />
              </Icon>

              <Icon
                className="detail"
                handleOnClick={e => handleEdit(e, {
                  tipo_id: node.tipo_id_first,
                  label: node.label_first,
                  nemotecnico: node.nemotecnico_first
                }, false)}
                id={`reduce-${node.block_name}${node.nemotecnico_first}`}
                isDisabled={isDisabledFirst}
                placement="right"
                tooltipText={(
                  <span className="show-tooltip">
                    Disminuir
                  </span>
                )}
              >
                <FontAwesomeIcon
                  className="table-link"
                  icon={faMinus}
                />
              </Icon>
            </>
          )}
        </div>
      </Row>
      <Row className="indirecta d-flex justify-content-between m-0">
        <div className="text-left col-md-4 p-0">
          {node.label_second}
        </div>
        <div className="col-md-5 text-right p-0">
          <NumberFormat
            decimalScale="2"
            fixedDecimalScale
            decimalSeparator=","
            displayType="text"
            value={detail.balance[node.nemotecnico_second]}
            thousandSeparator="."
          />
          &nbsp; UF
        </div>
        <div className="col-md-3 d-flex justify-content-end p-0">
          <Icon
            className="detail"
            handleOnClick={e => handleView(e, {
              tipo_id: node.tipo_id_second,
              label: node.label_second,
              nemotecnico: node.nemotecnico_second
            }, false)}
            id={`show-${node.block_name}${node.nemotecnico_second}`}
            placement="right"
            tooltipText={(
              <span className="show-tooltip">
                Ver Tabla
              </span>
            )}
          >
            <FontAwesomeIcon
              className="table-link"
              icon={faSearch}
            />
          </Icon>

          {node.block_name === 'Cúmulo' ? (
            <>
              <Icon
                className="Bloquear"
                handleOnClick={e => handleEdit(e, {
                  tipo_id: node.tipo_id_second,
                  label: node.label_second,
                  nemotecnico: node.nemotecnico_second
                })}
                id={`block-${node.block_name}${node.nemotecnico_second}`}
                placement="right"
                tooltipText={(
                  <span className="show-tooltip">
                    {detail.balance.bloqueada ? 'Desbloquear' : 'Bloquear'}
                  </span>
                )}
              >
                <FontAwesomeIcon
                  className="table-link"
                  icon={detail.balance.bloqueada ? faLockOpen : faLock}
                />
              </Icon>
            </>
          ) :
          (
            <>
              <Icon
                className="detail"
                handleOnClick={e => handleEdit(e, {
                  tipo_id: node.tipo_id_second,
                  label: node.label_second,
                  nemotecnico: node.nemotecnico_second
                }, true)}
                id={`increase-${node.block_name}${node.nemotecnico_second}`}
                isDisabled={isDisabledSecond}
                placement="right"
                tooltipText={(
                  <span className="show-tooltip">
                    Aumentar
                  </span>
                )}
              >
                <FontAwesomeIcon
                  className="table-link"
                  icon={faPlus}
                />
              </Icon>

              <Icon
                className="detail"
                handleOnClick={e => handleEdit(e, {
                  tipo_id: node.tipo_id_second,
                  label: node.label_second,
                  nemotecnico: node.nemotecnico_second
                }, false)}
                id={`reduce-${node.block_name}${node.nemotecnico_second}`}
                isDisabled={isDisabledSecond}
                placement="right"
                tooltipText={(
                  <span className="show-tooltip">
                    Disminuir
                  </span>
                )}
              >
                <FontAwesomeIcon
                  className="table-link"
                  icon={faMinus}
                />
              </Icon>
            </>
          )}
        </div>
      </Row>

      {isDisabledFirst && isUserHasProfileByNode(node) && (
        <p className="disable-warning">
          <span style={{ color: 'var(--orsan-blue)' }}>*</span>
          &nbsp; No se puede aumentar ni disminuir el monto de la Linea
        </p>
      )}
      {isDisabledSecond && isUserHasProfileByNode(node) && (
        <p className="disable-warning">
          <span style={{ color: 'var(--orsan-blue)' }}>*</span>
          &nbsp; No se puede aumentar ni disminuir el monto de la Linea de Proyectos
        </p>
      )}
    </div>
  );
};

TripleLineCard.propTypes = {
  detail: PropTypes.shape({
    balance: PropTypes.shape({
      bloqueada: PropTypes.bool,
    }),
  }).isRequired,
  handleEdit: PropTypes.func,
  handleView: PropTypes.func.isRequired,
  node: PropTypes.shape({
    block_name: PropTypes.string,
    block_id: PropTypes.number,
    label_first: PropTypes.string,
    nemotecnico_first: PropTypes.string,
    tipo_id_first: PropTypes.number,
    label_second: PropTypes.string,
    nemotecnico_second: PropTypes.string,
    tipo_id_second: PropTypes.number,
    total: PropTypes.string,
  }).isRequired,
};

TripleLineCard.defaultProps = {
  handleEdit: () => {},
};

export default TripleLineCard;
